<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllProduction()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                label="Shop"
                :items="shopList"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                :readonly="checkRoleShop() ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                label="Department"
                :items="departmentList"
                v-model="queryParams.departmentId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Production Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productionOrderNo"
                label="Production Order No"
                type="text"
                v-model="queryParams.productionOrderNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="emrNo"
                label="EMR No"
                type="text"
                v-model="queryParams.emrNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                label="Status"
                :items="statusList"
                item-text="label"
                item-value="value"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                label="Production Item Type"
                :items="productionItemList"
                v-model="queryParams.productionItemId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                @change="changeProductionItem()"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                label="WIP Status"
                :items="productionItemDetailList"
                v-model="queryParams.productionItemDetailId"
                item-text="processName"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productionList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lignten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  color="blue lignten-2"
                  @click.stop="printInvoice(props.item.id)"
                  :loading="printLoading"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.departmentName }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.productionOrderNo }}</td>
              <td>{{ props.item.emrNos }}</td>
              <td>{{ props.item.rmrNos }}</td>
              <td>{{ props.item.productionItemName }}</td>
              <td>{{ props.item.wipStatus }}</td>
              <td>{{ props.item.wipPercent }}</td>
              <td>{{ props.item.totalProductionCost | decFormat }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { productionService } from "../../services/production-service";
import { productionItemService } from "../../services/production-item-service";
import { shopService } from "../../services/shop-service";
import { departmentService } from "../../services/department-service";

export default {
  name: "ProductionList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "Production",
        disabled: true,
      },
    ],
    buttonLoading: false,
    printLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      shopId: "",
      name: "",
      productionOrderNo: "",
      emrNo: "",
      status: "",
      productionItemId: "",
      productionItemDetailId: "",
      departmentId: "",
      isAddDetail: false,
      isAddCostDetail: false,
    },
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Shop", value: "shop.name" },
      { text: "Department", value: "department.name" },
      { text: "Production Name", value: "name" },
      { text: "Production Order No", value: "productionOrderNo" },
      { text: "EMR No", sortable: false },
      { text: "RMR No", sortable: false },
      { text: "Production Item Type", value: "productionItem.name" },
      { text: "WIP Status", value: "productionItemDetail.processName" },
      { text: "WIP Percent(%)", value: "wipPercent" },
      { text: "Total Production Cost", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    productionList: [],
    shopList: [],
    departmentList: [],
    productionItemList: [],
    productionItemDetailList: [{ id: "", processName: "---ALL---" }],
    statusList: [{ label: "---ALL---", value: "" }],
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductionList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.shopId = this.checkRoleShop();
    this.getAllProductionStatus();
    this.getAllShop();
    this.getActiveDepartments();

    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = Number(this.$route.query.departmentId);
    }
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.productionOrderNo) {
      this.queryParams.productionOrderNo = this.$route.query.productionOrderNo;
    }
    if (this.$route.query.emrNo) {
      this.queryParams.emrNo = this.$route.query.emrNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.productionItemId) {
      this.queryParams.productionItemId = Number(
        this.$route.query.productionItemId
      );
    }
    if (this.$route.query.productionItemDetailId) {
      this.queryParams.productionItemDetailId = Number(
        this.$route.query.productionItemDetailId
      );
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    this.getActiveProductionItems().then(() => {
      if (this.queryParams.productionItemId) {
        this.getProductionItems();
      }
    });
  },
  methods: {
    checkRoleShop() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getActiveDepartments() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllProductionStatus() {
      productionService
        .getAllProductionStatus()
        .then((res) => {
          let tempList = res.data;
          tempList.forEach((temp) => {
            let tempObj = { label: temp, value: temp };
            this.statusList.push(tempObj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveProductionItems() {
      return productionItemService
        .getProductionItemsByStatus("ACTIVE", true)
        .then((res) => {
          this.productionItemList = res.data;
          this.productionItemList.unshift({ name: "---ALL---", id: "" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeProductionItem() {
      this.queryParams.productionItemDetailId = "";
      this.productionItemDetailList = [];
      if (this.queryParams.productionItemId) {
        this.getProductionItems();
      } else {
        this.productionItemDetailList = [{ id: "", processName: "---ALL---" }];
      }
    },
    getProductionItems() {
      let productionItem = commonService.search(
        "id",
        this.queryParams.productionItemId,
        this.productionItemList
      );
      if (productionItem) {
        this.productionItemDetailList = productionItem.productionItemDetailList;
        this.productionItemDetailList.unshift({
          id: "",
          processName: "---ALL---",
        });
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "productions", query: this.queryParams });
      this.getProductionList();
    },
    getProductionList() {
      this.showListLoading = true;
      this.queryParams.isAddDetail = false;
      this.queryParams.isAddCostDetail = false;
      let order = this.pagination.descending ? "desc" : "asc";
      productionService
        .getProductionList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productionList = res.data.productionHeaderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllProduction() {
      this.buttonLoading = true;
      this.queryParams.isAddDetail = true;
      this.queryParams.isAddCostDetail = true;
      productionService
        .getProductionExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    onRegister() {
      //go to detail page
      this.$router.push("/production/new");
    },
    onEdit(production) {
      //go to detail page
      this.$router.push("/production/" + production.id);
    },
    printInvoice(id) {
      this.printLoading = true;
      productionService
        .printInvoice(id)
        .then((res) => {
          var blob = res;
          productionService.showWindowDialog(blob, "invoice-" + id);
        })
        .finally(() => (this.printLoading = false));
    },
  },
};
</script>
